export const DEFAULT_CURRENCY = 'GBP';
export const DEFAULT_LOCALE = 'en-GB';
export const DISTRIBUTION_EMAIL = import.meta.env.VITE_APP_DISTRIBUTION_EMAIL;
export const MAX_TEXT_FIELD_LENGTH = 12000;
